export enum ApiCallStatus {
  none = 'none',
  pending = 'pending',
  success = 'success',
  error = 'error',
}
